import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "staging", "stagingDisplay", "formatHelp"]

  connect() {
    console.log("Import mapping controller connected")
  }

  // Handle file column selection and auto-fill staging name
  onSelectChange(event) {
    const select = event.target
    if (!(select.name && select.name.includes('[mapped_file_column_name]'))) return

    const td = select.closest('td')
    if (!td) return

    const nextTd = td.nextElementSibling
    if (!nextTd) return

    const stagingInput = nextTd.querySelector('input[name*="[staging_table_column_name]"]')
    const stagingDisplay = nextTd.querySelector('[data-mapping-target="stagingDisplay"]')
    if (!stagingInput) return

    const selected = select.value || ""
    if (selected === "") {
      stagingInput.value = ""
      if (stagingDisplay) stagingDisplay.textContent = ""
    } else {
      const normalized = this.normalizeIdentifier(selected)
      stagingInput.value = normalized
      if (stagingDisplay) stagingDisplay.textContent = normalized
    }
  }

  // Toggle format help section
  toggleHelp(event) {
    event.preventDefault()
    
    const details = document.querySelector('#format-help details')
    if (!details) return

    // Open the details element
    details.open = true

    // Scroll to the help section smoothly
    const helpSection = document.getElementById('format-help')
    if (helpSection) {
      helpSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  // Normalize identifier to PostgreSQL-compatible format
  normalizeIdentifier(s) {
    if (!s) return ""
    let ident = s.trim()
      .replace(/[^\p{L}\p{N}\s]+/gu, " ") // drop punctuation to spaces
      .replace(/\s+/g, "_")
      .toLowerCase()
    ident = ident.replace(/^([0-9])/, "_$1")
    return ident.substring(0, 63)
  }
}
